export const initPreview = () => {
  const tabs = document.querySelectorAll('.doc-card__tab');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      document.querySelector('.doc-card__tab.is-active').classList.remove('is-active');
      tab.classList.add('is-active');
    });
  });

  const autofix = document.querySelector('.autofix');
  if (autofix) {
    autofix.querySelector('.autofix__btn').addEventListener('click', () => {
      autofix.classList.toggle('is-open');
    });
  }

  const makeBtn = document.querySelector('.result__make');
  if (makeBtn) {
    makeBtn.addEventListener('click', () => {
      makeBtn.disabled = true;
      document.querySelector('.doc-card--edit').classList.add('is-loading');
      setTimeout(() => {
        window.location.href = 'final.html';
      }, 2000);
    });
  }

  const doc = document.querySelector('.doc');
  if (!doc) {
    return;
  }

  doc.addEventListener('click', (e) => {
    const field = e.target.closest('.doc__field');
    if (!field) {
      return;
    }

    if (e.target.closest('button')) {
      const input = field.querySelector('input');
      field.textContent = e.target.closest('.doc__ok') ? input.value : field.dataset.value;
      field.classList.remove('is-edit');
      return;
    }

    if (field.classList.contains('is-edit')) {
      return;
    }

    field.dataset.value = field.textContent.trim();
    field.classList.add('is-edit');
    field.innerHTML = `<input type="text" value="${field.dataset.value}"><button class="doc__ok" type="button" aria-label="Сохранить">✓</button><button type="button" aria-label="Отменить">✕</button>`;
    field.querySelector('input').focus();
  });
};
